<input type="file"
    id="fileInput"
    [accept]="accepts"
    name="file"
    #fileInput
    style="display: none"
    (change)="fileChosen($event)" />
<div class="fileContainer"
    [ngClass]="{
		'dropFileContainer': droppable,
		'hovering': hovering
	}">
    <div *ngIf="showFileName"
        [ngStyle]="{'width': width}"
        class="attachmentName">
        <label *ngIf="!fileName">
            <span translate>{{placeHolder | translate}}</span>
            <span *ngIf="required && !hideRequiredAsterisk"
                style="color: red; font-weight: bold;">*</span>
        </label>
        <label *ngIf="fileName">{{fileName}}</label>
    </div>
    <button mat-button
        *ngIf="!deletable || !fileName"
        #browseButton
        [disabled]="disabled"
        (click)="chooseFile()"
        translate>
        {{buttonLabel.toUpperCase()}}
    </button>
    <button mat-button
        *ngIf="deletable && fileName"
        #deleteButton
        [disabled]="disabled"
        (click)="delete()"
        translate>
        {{deleteLabel.toUpperCase()}}
    </button>
</div>